(ns teamoesterreich.user-mode.wana-help.lebensretter.helping-lebensretter
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.link :refer [link]]
            [reagent-material-ui.icons.person :refer [person]]
            [reagent-material-ui.icons.phone-iphone :refer [phone-iphone]]
            [reagent.core :as r]                            ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [teamoesterreich.config :as config]
            [teamoesterreich.lebensretter-checks :as h-check]
            [teamoesterreich.store :as store]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.modal.info-popup :as info-popup]
            [teamoesterreich.util.helper :as h]
            ))



(defn select-lr-source [!actual-user]
  (let [old-value (get-in @!actual-user [:lr-source])
        !st (r/atom {:changed false :value old-value})
        !changed (r/cursor !st [:changed])
        !value (r/cursor !st [:value])]
    (fn []
      [mui/grid
       {:container false
        :item      true
        :md        12                                       ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :style     #js {:padding "15px"}
        }
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "left"
         :alignItems "left"
         :spacing    4
         }
        [mui/grid
         {:container false
          :item      true
          :xs        6
          }
         [mui/form-label "Ich komme als Lebensretter aus folgender Organisation"
          [mui/select
           {
            :style     {:backgroundColor (if @!changed "#ffd6d2" "#ffffff")}
            :fullWidth true
            :value     @!value
            :onChange  (fn [e]
                         (reset! !value (h/event-value e))
                         (reset! !changed (not= @!value old-value)))
            :label     "Ich komme als Lebensretter aus folgender Organisation"}

           [mui/menu-item {:value "" :key ""} ""]
           [mui/menu-item {:value "Rotes Kreuz" :key "Rotes Kreuz"} "Rotes Kreuz"]
           [mui/menu-item {:value "Polizei" :key "Polizei"} "Polizei"]
           [mui/menu-item {:value "Feuerwehr" :key "Feuerwehr"} "Feuerwehr"]
           [mui/menu-item {:value "Bergrettung" :key "Bergrettung"} "Bergrettung"]
           [mui/menu-item {:value "Wasserrettung" :key "Wasserrettung"} "Wasserrettung"]
           [mui/menu-item {:value "OEGK" :key "OEGK"} "Österreichische Gesundheitskasse"]
           ]]]
        (when @!changed
          [mui/grid
           {:container false
            :item      true
            :xs        4
            } [mui/button
               {:variant "outlined"
                :color   "secondary"

                :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}
                :onClick #(a/set-user-details {:lr-source @!value})
                }
               "Speichern"]])
        ]])))

(defn needs-login []
  [mui/grid
   {:container false
    :item      true
    :xs        12                                           ;extra-small: 0px
    :style     #js {:padding "15px"}
    }
   [:h1
    "Nicht angemeldet"]
   [:div
    [:div {:style {}}
     (txt/txt :helping "Du must im angemeldet sein um mitmachen zu können!")]
    [mui/button
     {:variant "outlined"
      :color   "secondary"
      :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}
      :onClick #(a/open-login)
      }
     "Ich will mich anmelden"]]]
  )


(defn lr-button [!app-link]
  (when (nil? @!app-link)
    (reset! !app-link :loading)
    (a/get-lebensretter-link (fn [link]
                               (log/out link)
                               (reset! !app-link link))))
  (if (and @!app-link (not= @!app-link :loading))
    [mui/button {:variant   "outlined"
                 :color     "secondary"
                 :component "a"
                 :href      @!app-link
                 :target    "_blank"
                 :startIcon (r/as-element [link])}
     "Link öffnen"]
    [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 20} "lade..."]))


(defn lr-sb-button [!sb-link]
  (when (nil? @!sb-link)
    (reset! !sb-link :loading)
    (a/get-lebensretter-selfexplain-link (fn [link]
                                           (log/out link)
                                           (reset! !sb-link link))))
  (if (and @!sb-link (not= @!sb-link :loading))
    [mui/button {:variant   "outlined"
                 :color     "secondary"
                 :component "a"
                 :href      @!sb-link
                 :target    "_blank"
                 :startIcon (r/as-element [link])}
     "Zur Selbsterklärung"]
    [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 20} "lade..."]))




(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !user-documents (r/cursor store/app-state [:user-documents])
        !app-link (r/cursor store/app-state [:lr-app-link])
        !sb-link (r/cursor store/app-state [:lr-sb-link])
        !request-lebensretter (r/cursor store/app-state [:actual-user :request-lebensretter])
        !info-popup-message (r/cursor store/app-state [:info-popup])
        request-lebensretter-fn #(a/set-user-details {:request-lebensretter true :status-lebensretter true})
        request-out-lebensretter-fn #(a/set-user-details {:request-lebensretter false :status-lebensretter false})
        ]
    (a/set-bottom-action-fn #(a/set-page-back))

    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "10px"}
      }
     [info-popup/info-modal !info-popup-message "Ok" (fn [])]
     [mui/grid
      {:container false
       :item      true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :item      true
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          "Lebensretter"]
         [:p {:dangerouslySetInnerHTML {:__html (txt/txt :helping "Lebensretter-Kachel")}}]
         ]


        (when (not (:tom-id @!actual-user))
          [needs-login !actual-user])

        (when (and (:tom-id @!actual-user) (not @!request-lebensretter))
          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:h1
            "Voraussetzungen"]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-profile? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Vollständig ausgefülltes Profil"]]

           [:div {:class "check-line-icon"}
            (if (and (h-check/check-email? @!actual-user) (h-check/check-handy? @!actual-user)) [check] [close])]
           [:div {:class "check-line-text"}
            "Email und Handynummer validiert"]


           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-lr-app? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Lebensretter App installiert"]
            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-identity? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Identität bestätigt"]

            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-age? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Alter > 18 Jahre"]
            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-first-aid? @!user-documents) [check] [close])]
            [:div {:class "check-line-text"}
             "Nachweis der Erste Hilfe Kenntnisse"
             [:ul

              [:li "Erste Hilfe Kurs oder"]
              [:li "Wiederbelebungstraining oder"]
              [:li "Betrieblicher Ersthelfer oder"]
              [:li "Aktives Rettungsdienstpersonal (ehren- und hauptamtlich) oder"]
              [:li "Ärztin/Arzt oder"]
              [:li "Pflegepersonal oder"]
              [:li "Polizist/Polizistin oder"]
              [:li "Mitglied der Bergrettung"]

              ]]

            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-selfexplain? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Unterschriebene Selbsterklärung"]
            ]


           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-activated? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Freigabe durch Bearbeiter"]
            ]

           ])


        (when (and (= "toe" config/CLIENT) (:tom-id @!actual-user) @!request-lebensretter)
          [(select-lr-source !actual-user)])

        (when (and (:tom-id @!actual-user) @!request-lebensretter)
          [mui/grid
           {:container false
            :item      true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     #js {:padding "15px"}
            }
           [mui/button
            {:variant "outlined"
             :color   "secondary"

             :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}

             }
            "Ich helfe schon"]

           [mui/button
            {:variant "outlined"
             :style   #js {:margin "10px 0 10px 10px" :min-width "200px" :float "right"}
             :onClick #(request-out-lebensretter-fn)
             }
            "Abmelden"]])






        (when (and (:tom-id @!actual-user) @!request-lebensretter)

          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:h1
            "Voraussetzungen"]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-profile? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Vollständig ausgefülltes Profil"]
            [:div {:class "check-line-buttons"}
             [mui/button {:variant   "outlined" :color "primary"
                          :startIcon (r/as-element [person])
                          :onClick   #(a/set-page :wanaHelpLebensretter-profile-personal)}
              "Zu meinem Profil"]
             ]]


           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-email? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Email validiert"]
            (when-not (h-check/check-email? @!actual-user)
              [mui/button {:variant   "outlined" :color "primary"
                           :startIcon (r/as-element [email])
                           :onClick   #(a/verify-email)}
               "Email validieren"])]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (and (h-check/check-email? @!actual-user) (h-check/check-handy? @!actual-user)) [check] [close])]
            [:div {:class "check-line-text"}
             "Handynummer validiert"]
            (when-not (h-check/check-handy? @!actual-user)
              [mui/button {:variant   "outlined" :color "primary"
                           :startIcon (r/as-element [phone-iphone])
                           :onClick   #(a/verify-phone-number)}
               "Handy validieren"])]



           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-lr-app? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Lebensretter App installiert und mit diesem Account verbunden"]
            [lr-button !app-link]

            [mui/button {:variant   "outlined"
                         :color     "primary"
                         :startIcon (r/as-element [link])
                         :onClick   (fn [] (a/send-lebensretter-link #(reset! !info-popup-message "Email wurde gesendet!")))
                         }
             "Link zusenden"]
            ]


           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-identity? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Identität bestätigt"]
            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-age? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Alter > 18 Jahre"]
            ]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-selfexplain? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Unterschriebene Selbsterklärung (via App oder Dokument)"]
            [lr-sb-button !sb-link]]

           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-first-aid? @!user-documents) [check] [close])]
            [:div {:class "check-line-text"}
             "Nachweis der Erste Hilfe Kenntnisse"
             [:ul

              [:li "Erste Hilfe Kurs oder"]
              [:li "Wiederbelebungstraining oder"]
              [:li "Betrieblicher Ersthelfer oder"]
              [:li "Aktives Rettungsdienstpersonal (ehren- und hauptamtlich) oder"]
              [:li "Ärztin/Arzt oder"]
              [:li "Pflegepersonal oder"]
              [:li "Polizist/Polizistin oder"]
              [:li "Mitglied der Bergrettung"]

              ]
             ]
            [:div {:class "check-line-buttons"}
             [mui/button {:variant   "outlined"
                          :color     "primary"
                          :startIcon (r/as-element [person])
                          :onClick   #(a/set-page :wanaHelpLebensretter-profile-documents)
                          }
              "Zu meinen Dokumenten"]
             ]]


           [:div {:class "helping-check-line"}
            [:div {:class "check-line-icon"}
             (if (h-check/check-activated? @!actual-user) [check] [close])]
            [:div {:class "check-line-text"}
             "Freigabe durch Bearbeiter"]]



           [:br]
           [:br]
           [:h1
            "Was ich für einen Lebensretter Einsatz wissen muss"]
           [:a {:href (str (txt/txt :helping "Lebensretter-Doku.pdf")) :target "_blank"} "--> Link zum Infoblatt"]
           [:br]
           [:br]

           [:a {:href (str (txt/txt :helping "Lebensretter-Onboarding.pdf")) :target "_blank"} "--> Link zur Step by Step Anleitung"]

           [:br]
           [:br]
           (when false
             [:h1
              "Meine letzten/aktuellen Einsätze als Lebensretter"]
             )
           (when false
             [:p "kein Einsatz!"])

           ])


        (when (and (:tom-id @!actual-user) (not @!request-lebensretter))
          [mui/grid
           {:container false
            :item      true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     #js {:padding "15px"}
            }
           [mui/button
            {:variant  "outlined"
             :color    "secondary"
             :style    #js {:margin "10px 0 10px 10px" :min-width "200px"}
             :disabled (or (nil? (:birthday @!actual-user)) (not (h-check/check-age? @!actual-user)))
             :onClick  #(request-lebensretter-fn)
             }
            "Ich will mitmachen."]
           (cond
             (nil? (:birthday @!actual-user))
             [mui/typography {:color   "error"
                              :variant "body2"}
              "Du musst zuerst in deinem Profil dein Geburtsdatum eintragen"]

             (not (h-check/check-age? @!actual-user))
             [mui/typography {:color   "error"
                              :variant "body2"}
              "Du musst 18 Jahre alt sein, um dich als Lebensretter anzumelden"]
             )])

        (when (and (:tom-id @!actual-user) @!request-lebensretter)
          [mui/grid
           {:container false
            :item      true
            :md        5                                    ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:a
            {:href (txt/txt :helping "Lebensretter-IosApp") :target "_blank"}
            [:img {:alt "Itunes App " :src "/custom/img/apsStoresIos.png"}]
            ]
           ])


        (when (and (:tom-id @!actual-user) @!request-lebensretter)

          [mui/grid
           {:container false
            :item      true
            :md        5                                    ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:a
            {:href (txt/txt :helping "Lebensretter-AndroidApp") :target "_blank"}
            [:img {:alt "Android App " :src "/custom/img/apsStoresAndroid.png"}]
            ]

           ])

        [mui/grid
         {:container false
          :item      true
          :md        5                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :style     {:margin "10px 0 10px 10px" :width "200px"}
           :onClick   #(a/set-page-back)
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]

         ]

        ]]]]
    ))


